<script lang="ts">
  import type { RadioGroupModelValue } from './radio-group-provider.vue'
</script>

<script setup lang="ts">
  import RadioGroupProvider from './radio-group-provider.vue'
  import RadioGroupItem from './radio-group-item.vue'
  import { computed, type HTMLAttributes } from 'vue'
  import { cn, useGatForm } from '@gat-ship/vue-components'
  import { FieldLabel, Label } from '@gat-ship/vue-components'

  const props = defineProps<{
    class?: HTMLAttributes['class']
    label?: string
    disabled?: boolean
    fieldType?: 'default' | 'inset'
  }>()

  const modelValue = defineModel<RadioGroupModelValue>('modelValue', {
    required: true
  })

  const formContext = useGatForm()

  const _fieldType = computed(() => {
    if (formContext.isProvided) {
      return formContext.fieldType
    }
    return props.fieldType ?? 'inset'
  })
</script>

<template>
  <RadioGroupProvider
    v-model:model-value="modelValue"
    :disabled="props.disabled"
  >
    <div :class="cn('flex flex-col gap-1.5', props.class)">
      <FieldLabel v-if="label && _fieldType === 'inset'">{{
        label
      }}</FieldLabel>
      <Label v-else-if="label">{{ label }}</Label>
      <div
        role="radiogroup"
        :class="
          cn('flex w-full flex-col', {
            'gap-3': _fieldType === 'default' || _fieldType === undefined,
            'gap-0': _fieldType === 'inset'
          })
        "
        tabindex="-1"
        style="outline: none"
      >
        <FieldStack class="px-0" :field-type="_fieldType">
          <slot>
            <RadioGroupItem
              label="Light Mode"
              description="Pick a clean and classic light theme."
              value="light"
            />
            <RadioGroupItem
              label="Dark Mode"
              description="Select a sleek and modern dark theme."
              value="dark"
            />
            <RadioGroupItem
              label="System"
              description="Adapts to your device's theme."
              value="system"
            />
          </slot>
        </FieldStack>
      </div>
    </div>
  </RadioGroupProvider>
</template>
